import cx from 'classnames';
import { NewPriceIcon } from '@/NewPrice';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { useShowSkeleton } from '../hooks';

type Props = {
  discountedPrice: number;
  showNewPriceIcon?: boolean;
};

export default function Price({ discountedPrice, showNewPriceIcon }: Props) {
  const showSkeleton = useShowSkeleton();

  const wrapperStyles = cx(
    'flex font-bold gap-8 items-center items-end text-2xl',
    {
      'bg-grey-1 h-28 w-2/4 overflow-hidden': showSkeleton
    }
  );

  return (
    <div data-qa="price" className={wrapperStyles}>
      {showNewPriceIcon && <NewPriceIcon data-qa="new-price-icon" />}
      {showSkeleton ? null : `$${formatAndDropDecimal(discountedPrice)}`}
    </div>
  );
}
